export enum UserPreferenceCookies {
  SALESFORCE_CLIENT_NAME_RESOLVER = 'user_preference_client_name_resolver',
}
